/*
 * If we don't have a Submission Number yet, then we haven't successfully continued off the first page.
 *    In this situation, we don't yet want to display the Work Item Assistant on the page for entry of
 *    comments, file attachments, etc.
 */

// Setup the namespace for this logic
var workItemAsstExcluder = workItemAsstExcluder || {};

workItemAsstExcluder.initialize = function() {
	var field = page.getField("SubmissionNumber");
	if (field) {
		value = field.getValue();
		if (!value || value=="") {
			var assistant = $("div#work_item_assistant_group")[0];
			if (assistant) {
				assistant.style.display = "none";
			}
		}
	}
};